<template>
  <el-dialog title="" width="80%" :visible.sync="visible" :before-close="handleClose"  >
    <div style="width: 94%;max-height: 50%;margin: 0 auto;">111</div>
    <span slot="footer" style="width: 100%;display: inline-block;text-align: center">
      <el-button type="primary" @click="submitForm">预 览</el-button>
      <el-button type="primary" @click="submitForm">保 存</el-button>
      <el-button type="primary" @click="submitForm">删 除</el-button>
      <el-button type="primary" @click="submitForm">返 回</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { http } from '@/utils/axios'
export default {
  props: [

  ],
  name: 'CourseLocationFiles',
  data () {
    return {
      visible: false,
      form:{
        name:'',
      }
    }
  },
  methods: {
    getList () {

    },

    // 初始化
    init () {
      this.visible = true
      this.form.name = ''
    },


    // 处理弹窗关闭事件
    handleClose (msg) {
      this.visible = false
      this.$emit('close-registration-review-edit', msg)
    },

    // 提交
    submitForm () {
      this.visible = false
      // this.$emit('close-registration-review-edit', msg)
      this.$emit('getRootName',this.form.name)
    },
  },
  created () {
    this.getList()
  },
  computed: {
    getUId () {
      return localStorage.getItem('uid') 
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  @include flex(center, flex-start);
  .info{
    width: 50%;
    border-right: 1px solid  #4e5359;
    &:nth-last-child(1){
      border-right: none;
    }
    .info-title{
      @include font(18px,  #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form{
    .el-form-item{
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog{
  width: 60%;
}
.chooseCourse{
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses{
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose{
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child{
  border-right: none;
}
.el-checkbox__label{
  white-space: normal;
  padding-left: 5px;
}
</style>
